import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubmitReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 11.9375L4 6.4375C4 4.22836 5.79086 2.4375 8 2.4375H16C18.2091 2.4375 20 4.22836 20 6.4375V17.4375C20 19.6466 18.2091 21.4375 16 21.4375V21.4375",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 6.9375H9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 9.9375H9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.81079 22.5588L6.81079 15.0588L8.31079 15.0588L8.31079 22.5588L6.81079 22.5588Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.0607 19.0588L7.56068 15.5588L4.06068 19.0588L3.00002 17.9982L6.50002 14.4982C7.0858 13.9124 8.03555 13.9124 8.62134 14.4982L12.1213 17.9982L11.0607 19.0588Z",
			fill: "white"
		})
	]
});
export default SvgSubmitReport;
